<template>
	<c-dialog ref="dialog"  width="600" mode="slide" @resolve="editHandle">
		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="saas_id"></c-input>
			<c-form-item label="商户代码">
				<c-input name="saas_id" maxlength="50" disabled></c-input>
			</c-form-item>
			<c-form-item label="商户名称">
				<c-input name="saas_full_name" maxlength="50" disabled></c-input>
			</c-form-item>
              <c-form-item label="开通版本" required>
                <c-radio-group name="version_id" :options="versionOptions" v-model="versionId" :clear="false"></c-radio-group>
              </c-form-item>
			<c-form-item label="员工账号数" required tip="商家最多可添加的子账号数量">
				<c-input name="max_account_count" type="stepper" step-controls="side" range="1,500" append-text="个" v-model="max_account_count" :clear="false"></c-input>
			</c-form-item>
            <c-form-item label="授权开始时间" required>
                <c-datetime name="auth_start_date" type="datetime" format="yyyy-MM-dd"></c-datetime>
            </c-form-item>
			<c-form-item label="授权到期时间" required>
				<c-datetime name="auth_exp_date" type="datetime" format="yyyy-MM-dd" :clear="false"></c-datetime>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
import {mapState} from "vuex";

export default {
	computed: {
	},
	data() {
		return {
      defaultVersionId:0,
      versionId:0,
      max_account_count:99,
      versionOptions:[]//可选版本列表
    }
	},

  mounted() {
    this.initSaasVersion();
  },

	methods: {
    /*******加载版本下拉框数据*****************/
    initSaasVersion(keyword, resolve){
      this.request({
        url:'/sys_saas/version/list',
        data: {},
        success:data => {
          this.versionOptions = data.map(item => {
            return {
              name: item.version_name,
              value: item.id,
              data: item
            }
          })
        }
      })
    },

		/*********打开编辑框，初始化**********/
		open(data) {
			this.$refs.form.clear();
			this.$refs.form.set(data);
      this.defaultVersionId = data.version_id||0;
      this.max_account_count = data.max_account_count||99;
			//填充form表单
			this.$refs.dialog.open({
				  title: '修改版本信息'
			});
		},

		/*******编辑提交处理方法********/
		editHandle (stop, next){
      stop();
      if (this.defaultVersionId != this.versionId){
        this.$confirm({
          message:'修改商户的版本，将导致商家操作权限发生变更，请确认是否变更商家的开通版本？',  // 提示内容,
          buttonName: '确定修改',  // 确定按钮文字
          cancelButton: true,  // 是否显示取消按钮
          resolve: () => {
            this.submitEditHandle(stop, next);
          },  // 确定按钮回调
          cancel: () => {},  // 取消按钮回调
        });
      }else {
        this.submitEditHandle(stop, next);
      }
		},

		/*******编辑提交处理方法********/
		submitEditHandle (stop, next){
			this.$refs.form.submit({
				url: '/sys_saas/edit/versionInfo',
				rule: {
          version_id:'请选择版本',
					max_account_count: '请输入账号数',
          auth_start_date: '请选择授权开始时间',
					auth_exp_date: '请选择授权到期时间'
				},
				dataFormatter: data => {
					return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						message: '操作成功',  // 提示内容,
						type: 'success'
					});
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>